<template>
  <div
    class="d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap"
  >
    <span class="fs-12 fw-medium">
      Mostrando {{ showingFrom }} - {{ showingTo }} de {{ totalItems }} registros
    </span>

    <nav aria-label="Page navigation">
      <ul class="pagination mb-0 justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <a class="page-link icon" href="#" aria-label="Previous" @click.prevent="changePage(currentPage - 1)">
            <i class="material-symbols-outlined">keyboard_arrow_left</i>
          </a>
        </li>

        <li
          v-for="page in pages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
        </li>

        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <a class="page-link icon" href="#" aria-label="Next" @click.prevent="changePage(currentPage + 1)">
            <i class="material-symbols-outlined">keyboard_arrow_right</i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Pagination",
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
  },
  emits: ["update:page"],

  setup(props, { emit }) {
    const totalPages = computed(() =>
      Math.ceil(props.totalItems / props.pageSize)
    );

    const pages = computed(() => {
      const pageCount = totalPages.value;
      const maxVisible = 5;
      const pages: number[] = [];

      let start = Math.max(1, props.currentPage - Math.floor(maxVisible / 2));
      let end = start + maxVisible - 1;

      if (end > pageCount) {
        end = pageCount;
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    });

    const showingFrom = computed(() =>
      (props.currentPage - 1) * props.pageSize + 1
    );

    const showingTo = computed(() =>
      Math.min(props.currentPage * props.pageSize, props.totalItems)
    );

    const changePage = (page: number) => {
      if (page < 1 || page > totalPages.value || page === props.currentPage) return;
      emit("update:page", page);
    };

    return {
      pages,
      totalPages,
      changePage,
      showingFrom,
      showingTo,
    };
  },
});
</script>